import React from 'react';
import { Link, Text } from '@bufferapp/ui';
import { Tiktok } from '@bufferapp/ui/Icon';
import { black, grayDark, white } from '@bufferapp/ui/style/colors';
import styled from 'styled-components';
import { HC_UTM_PARAMS } from '~/utils/contants';

const PublishingNotificationContainer = styled.div`
  display: flex;
  margin-top: 14px;
  align-items: center;
`;

const TiktokIconWrapper = styled.div`
  background-color: ${black};
  border-radius: 100%;
  height: 18px;
  width: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    height: 12px;
    width: 12px;
  }
  position: relative;
  top: -5px;
`;

const MessageWrapper = styled.div`
  margin-left: 10px;
`;

const TextWrapper = styled.div`
  font-size: 0.85rem;
  color: ${grayDark};
`;

export const PublishingNotification = () => {
  return (
    <PublishingNotificationContainer>
      <TiktokIconWrapper>
        <Tiktok
          color={white}
          role="img"
          size="small"
          title="Larger video files may experience a delay with posting to Tiktok"
        />
      </TiktokIconWrapper>
      <MessageWrapper>
        <TextWrapper>
          <Text>
            {`Larger video files may experience a delay with posting to Tiktok. `}
            <Link
              newTab
              href={`https://support.buffer.com/hc/en-us/articles/360039250394?${HC_UTM_PARAMS}`}
              fontWeight="fontWeightLight"
            >
              Learn More
            </Link>
          </Text>
        </TextWrapper>
      </MessageWrapper>
    </PublishingNotificationContainer>
  );
};
